import Actions from '../actions/actions';
import { setBusy, setUnBusy } from './common/commonReducers';
import {
  SendlaneAccessToken,
  SendlaneListsResponse,
  SendlaneModel,
} from '../model/SendlaneModel';
import SendlaneCRUDActions from '../actions/SendlaneCRUDActions';

type ActionType = {
  type: string;
  lists: SendlaneListsResponse[];
  apiKeys: SendlaneAccessToken[];
  apiKey: SendlaneAccessToken;
};

const initialState: SendlaneModel = {
  busy: false,
  apiKeys: [],
  lists: [],
};

export const sendlane = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case SendlaneCRUDActions.busyAction:
      return setBusy(state);

    case SendlaneCRUDActions.retrieveLists: {
      return {
        ...state,
        lists: action.lists,
        busy: false,
      };
    }
    case SendlaneCRUDActions.retrieveApiKeys: {
      return {
        ...state,
        apiKeys: action.apiKeys,
        busy: false,
      };
    }
    case SendlaneCRUDActions.retrievedApiKey: {
      const { apiKeys } = state;
      const apiKeyIndex = apiKeys.findIndex(
        apiKey => apiKey.id === action.apiKey.id,
      );
      let newApiKeys;
      if (apiKeyIndex >= 0) {
        newApiKeys = Object.assign([], apiKeys, {
          [apiKeyIndex]: { ...action.apiKey, readOnly: false },
        });
      } else {
        newApiKeys = [{ ...action.apiKey, readOnly: false }, ...apiKeys];
      }
      return {
        ...state,
        busy: false,
        apiKeys: newApiKeys,
      };
    }
    case SendlaneCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
